export function navigation()
{
	const siteNavigation = document.getElementById('site-navigation');

	if (!siteNavigation)
	{
		console.log('Notice: No site navigation found.');
		return;
	}

	const menu = siteNavigation.getElementsByTagName('ul')[0];

	if ('undefined' === typeof menu)
	{
		console.log('Notice: No menu found.');
		return;
	}

	// siteNavigation.classList.remove('menu--visible');

	const menuToggle = document.createElement('button');

	menuToggle.setAttribute('type', 'button');
	menuToggle.setAttribute('aria-controls', 'site-navigation');
	menuToggle.classList.add('menu__toggle');
	menuToggle.innerHTML = `
		<span class="bar bar--one"></span>
		<span class="bar bar--two"></span>
		<span class="bar bar--three"></span>
	`;

	siteNavigation.prepend(menuToggle);

	menuToggle.addEventListener('click', function()
	{
		menu.classList.toggle('menu__list--visible');
		menuToggle.classList.toggle('menu__toggle--open');

		if (menuToggle.getAttribute('aria-expanded') === 'true')
		{
			menuToggle.setAttribute('aria-expanded', 'false');
		}
		else
		{
			menuToggle.setAttribute('aria-expanded', 'true');
		}
	});

	const subParents = siteNavigation.getElementsByClassName('menu__item--parent');

	for (const parent of subParents)
  {
		const subToggle = document.createElement('button');

		subToggle.classList.add('menu__sub-toggle');
		subToggle.innerHTML = '&#10010;';

		const subMenu = parent.getElementsByClassName('menu__menu')[0];

		parent.insertBefore(subToggle, subMenu);
	}

	const subToggles = siteNavigation.getElementsByClassName('menu__sub-toggle');

	for (const toggle of subToggles)
	{
		toggle.nextSibling.classList.remove('menu__menu--visible');

		toggle.addEventListener('click', function()
		{
			toggle.nextSibling.classList.toggle('menu__menu--visible');

			if (toggle.nextSibling.classList.contains('menu__menu--visible'))
			{
				toggle.innerHTML = '&#10006;';
			}
			else
			{
				toggle.innerHTML = '&#10010;';
			}
		});
	}

	document.addEventListener('click', function(event) {
		const clickInside = siteNavigation.contains(event.target);

		if (!clickInside)
		{
			menu.classList.remove('menu__menu--visible');
			menuToggle.setAttribute('aria-expanded', 'false');

			for (const toggle of subToggles)
			{
				toggle.nextSibling.classList.remove('menu__menu--visible');
				toggle.innerHTML = '&#10010;';
			}
		}
	});
}